"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const hauling_types_1 = require("./hauling.types");
const hauling_1 = require("services/report/hauling");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauling_1._getHaulingReport)(dataStates);
    if (response.isError) {
        dispatch({
            type: hauling_types_1.haulingTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { modified_date: new Date(item.modified_date), vessel: `${item.vessel_no_1} (${item.vessel_capacity_1} Ton),
           ${item.vessel_no_2} (${item.vessel_capacity_2} Ton)` });
            })
        };
        dispatch({ type: hauling_types_1.haulingTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: hauling_types_1.haulingTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: hauling_types_1.haulingTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: hauling_types_1.haulingTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: hauling_types_1.haulingTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: hauling_types_1.haulingTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const exportDocuments = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauling_1._exportReportHauling)(dataStates);
    if (response.isError) {
        dispatch({
            type: hauling_types_1.haulingTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        dispatch({ type: hauling_types_1.haulingTypes.SET_EXPORT_DOCUMENTS, payload: response });
    }
});
const clearDocuments = () => dispatch => {
    dispatch({ type: hauling_types_1.haulingTypes.CLEAR_EXPORT_DOCUMENTS, payload: '' });
};
exports.default = {
    getDataGrid,
    onCloseError,
    onSortChange,
    onFilterChange,
    clearDocuments,
    exportDocuments,
    onClickMutation,
    onDataStateChange,
};
